module.exports = __webpack_public_path__ + "static/img/product-swipe8.2dae35f6.png";